import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/admin/vendors/$vendorGuid/contacts')({ component: Outlet });
